
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router';
import { Modal } from 'react-bootstrap';
import * as Actions from 'actions';
import {ContainerLoader, TermsOfService} from '../';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        	new_password : '',
        	new_password_conf : '',
        	new_password_class_name : '',
        	new_password_conf_class_name : ''
        }
        this.displayName = 'ResetPassword';

        this.handlePasswordChange = this.handlePasswordChange.bind(this)
				this.handlePasswordConfChange = this.handlePasswordConfChange.bind(this)
				this.handleSubmit = this.handleSubmit.bind(this)
				this.handleKeyDown = this.handleKeyDown.bind(this)
    }

    handlePasswordChange(e) {
    	let {value} = e.target;

    	if(/[A-Z]+/.test(value) && /[0-9]+/.test(value) && /[A-Za-z0-9_\-\.]{8,}/.test(value)) {
    		this.setState({
    			new_password : value,
    			new_password_class_name : 'has-success'
    		})
    	}
    	else {
    		this.setState({
    			new_password_class_name : 'has-error',
    			new_password : value
    		})
    	}

    	if(this.state.new_password_conf_class_name === 'has-success' && value !== this.state.new_password_conf) {
    		this.setState({new_password_conf_class_name : 'has-error'})
    	}
    	else if(this.state.new_password_conf_class_name === 'has-error' && value === this.state.new_password_conf) {
    		this.setState({new_password_conf_class_name : 'has-success'})
    	}
    }

    handlePasswordConfChange(e) {
    	let {value} = e.target;

    	if(/[A-Z]+/.test(value) && /[0-9]+/.test(value) &&
    		/[A-Za-z0-9_\-\.]{8,}/.test(value) && value === this.state.new_password) {
    		this.setState({
    			new_password_conf : value,
    			new_password_conf_class_name : 'has-success'
    		})
    	}
    	else {
    		this.setState({
    			new_password_conf : value,
    			new_password_conf_class_name : 'has-error'
    		})
    	}
    }

    handleKeyDown(e) {
    	if(e.key === 'Enter')
    		this.handleSubmit()
    }

    handleSubmit() {
    	let user = this.props.users.tmp_user;

    	this.props.beginSaveNewPassword({
    		_id : user._id,
    		temp_hash : user.temp_hash,
    		password : this.state.new_password,
    		password_confirm : this.state.new_password_conf
    	})
    }

    render() {

      return (
      	<section className='body-sign signup-form-container'>
          <div className='center-sign'>
            <a href='/' className='logo pull-left'>
              <img src='assets/images/logo-default.png' height='54' alt='Hailtrace App' />
            </a>
            <div className='panel panel-sign'>
              <div className='panel-title-sign mt-xl text-right'>
                <h2 className='title text-uppercase text-weight-bold m-none'><i className='fa fa-user mr-xs'></i> Reset Password</h2>
              </div>
              <div className='panel-body'>
              	<div className='row'>
              		<div className='col-md-12'>
              			<p>Passwords must have at least 8 characters, an upper-case letter, and a number.</p>
              		</div>
              	</div>
              	<hr className='dotted short' />
								<div className={`form-group mb-lg ${this.state.new_password_focused ? this.state.new_password_class_name : ''}`}>
									<div className='row'>
										<div className='col-md-12'>
											<label>Enter New Password</label>
											<input
												onChange={this.handlePasswordChange}
												type='password'
												id='password-input'
												className='form-control input-lg'
												value={this.state.new_password}
												autoFocus
												onFocus={() => {this.setState({
								    			new_password_focused : true,
								    			new_password_conf_focused : false
								    		})}}
								    		onKeyDown={this.handleKeyDown}
											/>
										</div>
									</div>
								</div>
								<div className={`form-group mb-lg ${this.state.new_password_conf_focused ? this.state.new_password_conf_class_name : ''}`}>
									<div className='row'>
										<div className='col-md-12'>
											<label>Confirm New Password</label>
											<input
												onChange={this.handlePasswordConfChange}
												id='password-conf-input'
												type='password'
												className='form-control input-lg'
												value={this.state.new_password_conf}
												onFocus={() => {this.setState({
								    			new_password_focused : false,
								    			new_password_conf_focused : true
								    		})}}
								    		onKeyDown={this.handleKeyDown}
											/>
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-md-12'>
										<div
											className='pull-right btn btn-primary'
											onClick={this.handleSubmit}
											>
											Submit
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
      );
    }
}

let mapStateToProps = ({users}) => ({users})

export default connect(mapStateToProps, Actions)(ResetPassword);



// WEBPACK FOOTER //
// ./src/browser/components/sales/resetPassword.js